// extracted by mini-css-extract-plugin
module.exports = {"Pricing":"Pricing_Pricing__2drpF","tableHeader":"Pricing_tableHeader__1r9nB","Button":"Pricing_Button__2uloF"};